import React, { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { updateUser } from '@/actions/user';
import DetailTitle from '@/components/menus/DetailTitle';
import useUser from '@/hooks/useUser';
import { useUiStatus } from '@/hooks/useUiStatus';
import { favoritePost } from '@/domains/firestore/user';
import { IMenu } from '@/@types/generated/contentful';

type ComponentProps = {
  menu: IMenu;
};

const DetailTitleContainer: React.FC<ComponentProps> = ({ menu }) => {
  const [isLoading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { setModalState } = useUiStatus();
  const user = useUser();
  const isFavorite = !!user?.favorited?.includes(menu.fields.id);
  const handleRequestUpdateFavorite = useCallback(
    async (postId: string) => {
      if (!user) {
        setModalState(true);
      } else {
        setLoading(true);
        await favoritePost({ userId: user.uid, postId });
        await dispatch(updateUser(user.uid));
        setLoading(false);
      }
    },
    [dispatch, setModalState, user]
  );
  return (
    <DetailTitle
      menu={menu}
      onRequestUpdateFavorite={handleRequestUpdateFavorite}
      isFavorite={isFavorite}
      invalid={isLoading}
    />
  );
};

export default DetailTitleContainer;
